// The company Billing page reuses the full subscription + Razorpay + invoice
// flow from the shared billing page. All /billing endpoints are now
// company-scoped on the backend, so the Admin manages the COMPANY plan here
// (runs/seats draw from one shared pool).
import BillingPage from "@/pages/dashboard/Billing";

export default function CompanyBilling() {
  return <BillingPage />;
}
